import * as echarts from "echarts";

export const timeOptions = {
  title: {},
  tooltip: {
    trigger: 'axis'
  },
  dataZoom: [
    {
      xAxisIndex: 0, // 这里是从X轴的0刻度开始
      show: false, // 是否显示滑动条，不影响使用
      type: "slider", // 这个 dataZoom 组件是 slider 型 dataZoom组件
      startValue: 0, // 从头开始。
      endValue: 4, // 一次性展示多少个。
    }
  ],
  grid: {
    left: '3%',
    right: '4%',
    top: '5%',
    bottom: '25%',
    containLabel: true
  },
  legend: {
    itemHeight: 6,
    bottom: '15%',
    data: [ '已完成', '未完成', '进行中' ],
    textStyle: {
      color: 'auto'        // 图例文字颜色
    }
  },
  calculable: true,
  xAxis: [
    {
      type: 'category',
      data: [],
      axisLabel: {
        interval: 0,
        show: true,
        textStyle: {
          color: '#c3dbff',  //更改坐标轴文字颜色
          fontSize : 12      //更改坐标轴文字大小
        }
      },
      nameTextStyle: {
        fontSize: 15,
        align: 'center'
      },
    }
  ],
  yAxis: [
    {
      type: 'value'
    }
  ],
  series: [ {
    name: '已完成',
    type: 'line',
    smooth: true,
    data: [],
    itemStyle: {
      color: '#FFA800'
    },
    label: {
      color: 'inherit'
    }
  }, {
    name: '未完成',
    type: 'line',
    smooth: true,
    data: [],
    itemStyle: {
      color: '#287CE8'
    }
  }, {
    name: '进行中',
    type: 'line',
    smooth: true,
    data: [],
    itemStyle: {
      color: '#41E4DE'
    }
  } ]
}
export const countOptions = {
  title: {},
  tooltip: {
    trigger: 'axis'
  },
  dataZoom: [
    {
      xAxisIndex: 0, // 这里是从X轴的0刻度开始
      show: false, // 是否显示滑动条，不影响使用
      type: "slider", // 这个 dataZoom 组件是 slider 型 dataZoom组件
      startValue: 0, // 从头开始。
      endValue: 4, // 一次性展示多少个。
    }
  ],
  grid: {
    left: '3%',
    right: '4%',
    top: '5%',
    bottom: '25%',
    containLabel: true
  },
  legend: {
    itemHeight: 6,
    bottom: '15%',
    data: [ '已完成', '未完成', '进行中' ],
    textStyle: {
      color: 'auto'        // 图例文字颜色
    }
  },
  calculable: true,
  xAxis: [
    {
      type: 'category',
      data: [],
      axisLabel: {
        interval: 0,
        show: true,
        textStyle: {
          color: '#c3dbff',  //更改坐标轴文字颜色
          fontSize : 12      //更改坐标轴文字大小
        }
      },
      nameTextStyle: {
        fontSize: 15,
        align: 'center'
      },
    }
  ],
  yAxis: [
    {
      type: 'value'
    }
  ],
  series: [
    {
    name: '已完成',
    type: 'bar',
    data: [],
    itemStyle: {
      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [ {
        offset: 0, //offset范围是0~1，用于表示位置，0是指0%处的颜色
        color: '#57f35f'
      }, {
        offset: 1,
        color: '#4d9062'
      } ])
    }
  }, {
    name: '未完成',
    type: 'bar',
    data: [],
    itemStyle: {
      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [ {
        offset: 0, //offset范围是0~1，用于表示位置，0是指0%处的颜色
        color: '#005BEA'
      }, {
        offset: 1,
        color: '#00C1DE'
      } ])
    }
  }, {
    name: '进行中',
    type: 'bar',
    data: [],
    itemStyle: {
      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [ {
        offset: 0, //offset范围是0~1，用于表示位置，0是指0%处的颜色
        color: '#eaa000'
      }, {
        offset: 1,
        color: '#6b6f0f'
      } ])
    }
  } 
  ]
}
